import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React from "react";
import Modal from "react-modal";
const antIcon = <LoadingOutlined style={{ fontSize: 24, align: "center" }} spin />;
const ConfirmationModal = ({ header, isOpen, loader, content, onConfirm, onClose, btnName }) => {
  return (
    <>
      <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        onRequestClose={onClose}
        contentLabel="Delete Modal"
        portalClassName="react-modal confirmation-modal"
        overlayClassName="modal"
        shouldCloseOnOverlayClick={false}
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered "
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">{header}</h5>
          </div>
          <div className="react-modal-body">
            <p className="react-modal-body-text">{content}</p>
          </div>
          <div className="react-modal-footer text-center">
            <div className="react-foo-container">
              <button type="button" onClick={onClose} className="btn btn-white">
                Close
              </button>
              <button type="button" onClick={() => onConfirm()} className="btn btn-primary">
                {btnName}
                {loader ? <Spin indicator={antIcon}></Spin> : ""}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ConfirmationModal;
